import { Menu } from "lucide-react";
import { Button } from "@/components/ui/button";

interface HeaderProps {
  onMenuClick: () => void;
}

const Header = ({ onMenuClick }: HeaderProps) => {
  return (
    <header className="fixed top-0 left-0 right-0 h-14 bg-background/80 backdrop-blur-lg border-b md:hidden z-40 transition-all duration-300">
      <div className="flex items-center justify-between px-3 sm:px-4 h-full">
        <Button
          variant="ghost"
          size="sm"
          className="md:hidden transition-transform duration-200 active:scale-95 -ml-2"
          onClick={onMenuClick}
        >
          <Menu className="h-5 w-5" />
        </Button>

        <div className="text-xl sm:text-2xl font-extrabold tracking-tight bg-gradient-to-r from-gray-900 to-gray-600 bg-clip-text text-transparent transition-all duration-300">
          Centse
        </div>

        <div className="w-8 sm:w-10" />
      </div>
    </header>
  );
};

export default Header;